module.exports = "<ui-view></ui-view>\n"